export const REGION_COUNTRIES = 'REGION_COUNTRIES'

export const ERROR_STATE = 'ERROR_STATE'
